import InventoryDealerInfo from './InventoryDealerInfo';

export default InventoryDealerInfo;
